/**
 * #7283 C/D (CodeRabbit security note): browser-local dispatch storage keys
 * are namespaced by the AUTHENTICATED account so one account's Event Notes
 * collapse state or send-dialog drafts can never surface for another user on
 * a shared browser. The identity comes from the JWT payload the auth service
 * persists at lsKeys.userInfo ('user_info'); an anonymous or unparseable
 * payload falls back to ':anon' (same bucket tests and pre-boot reads use).
 */
export function dispatchStorageKey(base: string, getItem: (k: string) => string | null = localStorage.getItem.bind(localStorage)): string {
    let id = 'anon';
    try {
        const raw = getItem('user_info');
        const parsed = raw ? JSON.parse(raw) : null;
        if (parsed && typeof parsed === 'object' && typeof parsed.id === 'string' && parsed.id) {
            id = parsed.id;
        }
    } catch { /* anonymous fallback */ }
    return `${base}:${id}`;
}